module.exports = __webpack_public_path__ + "static/img/bg-id.eaf8255d.webp";